'use strict';
/* globals constants */

var temp = {

  loginManualDispatch: function(what, payload) {
    this.dispatch(what, payload);
  },

  loginResetState: function() {
    this.dispatch(constants.RESET_LOGIN);
  },

  handleXHR: function(next, xhr, payload, dispatch) {
    if (xhr.responseText.substring(0, 15) === '<!DOCTYPE html>' && xhr.status == 200) {
      var url;
      var responseHeaders = xhr.getAllResponseHeaders().split('\n');
      for (var i = 0, len = responseHeaders.length; i < len; i++) {
        var val = responseHeaders[i].split(':').splice(1).join(':').trim();
        if (val.substring(0, 4) === 'http') {
          url = val;
          break;
        }
      }
      if (url !== undefined) {
        dispatch(constants.DISPLAY_LOGIN, { dispatch: next, url: url, payload: payload });
      }
    }
  }

};

if (window.actions !== undefined) {
  for (var attrname in temp) {
    window.actions[attrname] = temp[attrname];
  }
} else {
  window.actions = temp;
}